"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var phone_1 = require("./phone");

exports.MaskPHONE = phone_1.MaskPHONE;

var cpf_1 = require("./cpf");

exports.MaskCPF = cpf_1.MaskCPF;

var cnpj_1 = require("./cnpj");

exports.MaskCNPJ = cnpj_1.MaskCNPJ;

var cep_1 = require("./cep");

exports.MaskCEP = cep_1.MaskCEP;

var date_1 = require("./date");

exports.MaskDATE = date_1.MaskDATE;

var hour_1 = require("./hour");

exports.MaskHOUR = hour_1.MaskHOUR;

var currency_1 = require("./currency");

exports.MaskCURRENCY = currency_1.MaskCURRENCY;

var percent_1 = require("./percent");

exports.MaskPERCENT = percent_1.MaskPERCENT;

var cpfCnpj_1 = require("./cpfCnpj");

exports.MaskCPFCNPJ = cpfCnpj_1.MaskCPFCNPJ;

var contaCorrente_1 = require("./contaCorrente");

exports.MaskCC = contaCorrente_1.MaskCC;

var barCode_1 = require("./barCode");

exports.MaskBarCode = barCode_1.MaskBarCode;

var onlyNumber = function onlyNumber(value) {
  return value.replace(/\D/g, '');
};

exports.onlyNumber = onlyNumber;

var onlyLetters = function onlyLetters(value) {
  return value.replace(/([^a-zA-ZÀ-ÿ- ])/g, '');
};

exports.onlyLetters = onlyLetters;

var isValidName = function isValidName(value) {
  return !!value.match(/^([a-zA-ZÀ-ÿ- ]{2,}\s[a-zA-ZÀ-ÿ- ]{1,}'?-?[a-zA-ZÀ-ÿ- ]{1,}\s?([a-zA-ZÀ-ÿ- ]{1,})?)/);
};

exports.isValidName = isValidName;

var percent = function percent(value) {
  return value.replace(/\D/g, '').replace(/(\d\d?)$/, '$1%');
};

exports.percent = percent;

var decimalNumber = function decimalNumber(value) {
  var commaCount = value.match(/,/g);

  if (commaCount && commaCount.length > 1) {
    return value.replace(/[^\d,-]/g, '').split('').filter(function (item, i) {
      return i !== value.indexOf(',');
    }).join('');
  } else {
    return value.replace(/[^\d,-]/g, '');
  }
};

exports.decimalNumber = decimalNumber;